<script>
  export let pkgDependencies;

  let newDependency=''
</script>

{#each pkgDependencies || [] as dependency, i}
  <div>
    {dependency}
    <button on:click={() => {pkgDependencies = [...pkgDependencies.slice(0, i), ...pkgDependencies.slice(i+1)]}}> - </button>
  </div>
{/each}

<div>
  <input bind:value={newDependency}/> 
  <button on:click={() => {pkgDependencies = [...(pkgDependencies || []), newDependency]}}> + </button>
</div>